import { catchError, finalize, map } from 'rxjs/operators';
import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { MessageService } from '../../../core/service/message.service';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { FastighetsagarnaDokumentTemplate } from '../../model/fastighetsagarna-dokument-template';
import { DataService } from '../../../core/service/base/data.service';

@Injectable()
export class FastighetsagarnaDokumentService extends DataService<FastighetsagarnaDokumentTemplate> {
  constructor(client: HttpClient, @Inject(APP_CONFIG) config: IAppConfig, messageService: MessageService, progressBar: ProgressBarService) {
    super(client, config, messageService, FastighetsagarnaDokumentTemplate, progressBar, 'fastighetsagarna-dokument');
  }

  createFormCase(leaseAgreementId: string, formCode: string): Observable<any> {
    this.progressBar.start();
    return this.client.post(`${this.endpoint}/create-formcase`, JSON.stringify({ id: leaseAgreementId, formCode: formCode })).pipe(
      catchError((errorResponse: HttpErrorResponse) => {
        if (errorResponse.error) this.notification.showError(errorResponse.error);
        throw errorResponse;
      }),
      finalize(() => this.progressBar.stop())
    );
  }

  deleteFormCase(leaseAgreementId: string, formCode: string): Observable<any> {
    this.progressBar.start();
    return this.client.post(`${this.endpoint}/delete-formcase`, JSON.stringify({ id: leaseAgreementId, formCode: formCode })).pipe(
      catchError((errorResponse: HttpErrorResponse) => {
        if (errorResponse.error) this.notification.showError(errorResponse.error);
        throw errorResponse;
      }),
      finalize(() => this.progressBar.stop())
    );
  }

  openFormCase(leaseAgreementId: string, formCode: string): Observable<any> {
    this.progressBar.start();
    return this.client.post(`${this.endpoint}/open-formcase`, JSON.stringify({ id: leaseAgreementId, formCode: formCode })).pipe(
      catchError((errorResponse: HttpErrorResponse) => {
        if (errorResponse.error) this.notification.showError(errorResponse.error);
        throw errorResponse;
      }),
      finalize(() => this.progressBar.stop())
    );
  }

  getDwellingTemplates(): Observable<FastighetsagarnaDokumentTemplate[]> {
    this.progressBar.start();
    return this.client.get<FastighetsagarnaDokumentTemplate[]>(`${this.endpoint}/get-dwellingtemplates`).pipe(
      map(response => this.toModels(response)),
      finalize(() => this.progressBar.stop())
    );
  }

  getPremisesTemplates(): Observable<FastighetsagarnaDokumentTemplate[]> {
    this.progressBar.start();
    return this.client.get<FastighetsagarnaDokumentTemplate[]>(`${this.endpoint}/get-premisestemplates`).pipe(
      map(response => this.toModels(response)),
      finalize(() => this.progressBar.stop())
    );
  }

  getOtherTemplates(): Observable<FastighetsagarnaDokumentTemplate[]> {
    this.progressBar.start();
    return this.client.get<FastighetsagarnaDokumentTemplate[]>(`${this.endpoint}/get-othertemplates`).pipe(
      map(response => this.toModels(response)),
      finalize(() => this.progressBar.stop())
    );
  }

  getParkingTemplates(): Observable<FastighetsagarnaDokumentTemplate[]> {
    this.progressBar.start();
    return this.client.get<FastighetsagarnaDokumentTemplate[]>(`${this.endpoint}/get-parkingtemplates`).pipe(
      map(response => this.toModels(response)),
      finalize(() => this.progressBar.stop())
    );
  }
}
